<template>
  <main :style="{ backgroundImage: `url(${meta.bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
    <logo large class="mg" />

    <div id="regPanel">
      <div class="title-btn" @click="goToLogin">
        {{ $t('reg["Login"]') }}
      </div>

      <div id="title">
        <span style="font-size: 40px;color: #FF5F00;z-index: 1">{{ $t('reg["Register"]') }}</span>&nbsp;
        <span style="
          font-weight: 600;
          font-size: 20px;
          color: #000000;
          line-height: 28px;
          text-align: left;
          font-style: normal;">
          {{ $t('reg["Your Account"]') }}
        </span>
      </div>

      <div id="panel">
        <div class="label-wrap">
          <label for="ipt-email">
            <img src="./images/email.png" alt="">
            <span>{{ $t('reg["Email"]') }}</span>
          </label>
        </div>
        <div class="ipt-wrap">
          <input v-model="form.email" type="email" id="ipt-email" maxlength="64"
                 :placeholder="$t('login[\'Please enter email address\']')">
        </div>

        <div v-if="meta.emailValidation" class="ipt-wrap form-input-code">
          <input :placeholder="$t('login[\'Enter code\']')"
                 type="text" class="ipt-code" v-model="form.code">
          <button class="loginBtn getCode" @click="sendEmailCode">{{ emailValidation.getCodeButtonLabel }}</button>
        </div>

        <div class="ipt-wrap ipt-pwd-wrap">
          <input v-model="form.password" :type='pwdFlag?"password":"text"'
                 :placeholder="$t('login[\'Please enter your password\']')" maxlength="64">
          <div class="ipt-pwd-eye-wrap">
            <img v-show="pwdFlag" src="@/assets/eye-closed.svg" alt="" @click="changePwd">
            <img v-show="!pwdFlag" src="@/assets/eye-open.svg" alt="" @click="changePwd">
          </div>
        </div>
        <div class="ipt-wrap ipt-pwd-wrap">
          <input v-model="form.passwordConfirm" :type='pwdFlag?"password":"text"'
                 :placeholder="$t('reg[\'Please confirm your password\']')" maxlength="64">
          <div class="ipt-pwd-eye-wrap">
            <img v-show="pwdFlag" src="@/assets/eye-closed.svg" alt="" @click="changePwd">
            <img v-show="!pwdFlag" src="@/assets/eye-open.svg" alt="" @click="changePwd">
          </div>
        </div>
        <div class="label-wrap">
          <label for="ipt-user-nickname">
            <img src="./images/person.png" alt="">
            <span>{{ $t('reg["Name"]') }}</span>
          </label>
        </div>
        <div class="ipt-wrap">
          <input v-model="form.userNickname" type="text" id="ipt-user-nickname"
                 maxlength="32" :placeholder="$t('reg[\'Please enter your name\']')">
        </div>
        <div class="label-wrap">
          <label for="ipt-phone">
            <img src="./images/tel.png" alt="">
            <span>{{ $t('reg["Contact number"]') }}</span>
          </label>
        </div>
        <div class="ipt-wrap ipt-phone-wrap">
          <foreign-area @country="v => (countryId = v)"></foreign-area>
          <input v-model="form.phoneNumber" type="tel" id="ipt-phone"
                 @input="() => form.phoneNumber = form.phoneNumber.replaceAll(/[^0-9]+/g,'').slice(0,11)"
                 :placeholder="$t('reg[\'Please enter your phone number\']')">
        </div>
        <div class="label-wrap">
          <label>
            <img-modal>
              <img src="./images/tag.png" alt="">
              <span>{{ $t('reg["Dog Tag ID"]') }}</span>
              <i class="el-icon-question"></i>
            </img-modal>
          </label>
        </div>
        <div class="ipt-wrap">
          <input v-model="form.dogTagId" type="text" maxlength="15"
                 :placeholder="$t('reg[\'Please enter your dog tagId\']')">
        </div>
      </div>
    </div>

    <privacy-agreement-check-box v-model="readInfo" />

    <div id="RegBtn" @click="doReg">
      <div>
        {{ $t('reg["Register"]') }}
      </div>
    </div>

    <custom-dialog
      v-model="showDialog"
      width="500"
      :confirmText="$t('base.ok')"
      cancelType="primary"
      :confirmBtnLoading="confirmBtnLoading"
      @confirm="showDialog = false"
      @change="changeModel"
      :title="$t('base.notice')"
      :info="confirmInfo">
      <div>
        {{ confirmInfo }}
      </div>
    </custom-dialog>

    <custom-dialog
      v-model="showDialog2"
      width="500"
      :confirmText="$t('base.ok')"
      cancelType="primary"
      :confirmBtnLoading="confirmBtnLoading"
      @confirm="confirmModel2"
      @change="changeModel2"
      :title="$t('base.notice')"
    >
      <div>
        {{ confirmInfo2 }}
      </div>
    </custom-dialog>

    <custom-dialog
      v-model="showDialog3"
      width="500"
      :confirmText="$t('base.ok')"
      cancelType="primary"
      :confirmBtnLoading="confirmBtnLoading"
      @confirm="confirmModel3"
      @change="changeModel3"
      :title="$t('base.notice')"
    >
      <div>
        {{ confirmInfo3 }}
      </div>
    </custom-dialog>

    <custom-dialog
      v-model="showDialog4"
      width="500"
      :confirmText="$t('base.ok')"
      cancelType="primary"
      :confirmBtnLoading="confirmBtnLoading"
      @confirm="confirmModel4"
      @change="changeModel4"
      :title="$t('base.notice')"
    >
      <div>
        {{ confirmInfo3 }}
      </div>
    </custom-dialog>

  </main>
</template>

<script>
import meta from '../../utils/meta'
import axios from "../../utils/request";
import CustomDialog from "../../components/alert.vue";
import foreignArea from "@/components/foreignArea.vue"
import PrivacyAgreementCheckBox from "../../components/PrivacyAgreementCheckBox.vue";
import ImgModal from "../../components/ImgModal.vue";

export default {
  name: 'reg',
  components: {ImgModal, PrivacyAgreementCheckBox, CustomDialog,foreignArea},
  comments: {
    CustomDialog,
    foreignArea
  },
  data() {
    return {
      confirmInfo4: '',
      showDialog4: false,
      confirmInfo3: '',
      showDialog3: false,
      confirmInfo2: '',
      showDialog2: false,
      confirmInfo: '',
      showDialog: false,
      readInfo: false,
      pwdFlag: true,
      confirmBtnLoading: false,
      countryId: 'America +1',
      form: {
        "dogTagId": '',
        "userNickname": '',
        "email": '',
        "password": '',
        "passwordConfirm": '',
        "phoneNumber": '',
        'code': ''
      },
      emailValidation: {
        getCodeButtonLabel: this.$t('login[\'Get code\']')
      },
      meta
    }
  },
  methods: {
    changePwd:function(){
      //密码标示取反即可
      this.pwdFlag=!this.pwdFlag;
    },
    goToLogin(){
      this.$router.push('/login')
    },
    confirmModel4() {
      this.showDialog4 = false;
      this.$router.push('/person_center')
    },
    changeModel4() {
      this.showDialog4 = false;
    },
    confirmModel3() {
      this.showDialog3 = false;
    },
    changeModel3() {
      this.showDialog3 = false;
    },
    confirmModel2() {
      this.showDialog2 = false;
    },
    changeModel2() {
      this.showDialog2 = false;
    },
    changeModel() {
      this.showDialog = false;
    },
    /**
     * @desc 确定按钮事件
     */
    ajaxDoReg() {
      this.confirmBtnLoading = true;
      // 处理业务逻辑相关的代码
      this.confirmBtnLoading = false;
      this.showDialog = false;

      if (meta.emailValidation && this.form.code.trim().length !== 6) {
        this.confirmInfo3 = this.$t('reg["Invalid email verification code"]')
        this.showDialog3 = true
        return
      }

      // email test
      if (!/^.+@.+\..+$/.test(this.form.email.trim())) {
        this.confirmInfo3 = this.$t('reg["Email address not valid."]')
        this.showDialog3 = true
        return
      }
      this.form.email = this.form.email.trim()

      // password test
      if (this.form.password.length < 6) {
        this.confirmInfo3 = this.$t('reg["Password must not less then 6 characters."]')
        this.showDialog3 = true
        return
      }
      if (this.form.password !== this.form.passwordConfirm) {
        this.confirmInfo3 = this.$t('reg["Password mismatch."]')
        this.showDialog3 = true
        return
      }

      // phone number test
      if (!this.form.phoneNumber.trim()) {
        this.confirmInfo3 = this.$t('reg["Please enter your phone number"]')
        this.showDialog3 = true
        return
      }

      // dogTagId test
      if (this.form.dogTagId.trim() === '') {
        this.confirmInfo3 = this.$t('reg["Please input dog tag Id."]')
        this.showDialog3 = true
        return
      }
      this.form.dogTagId = this.form.dogTagId.trim()

      if (this.readInfo) {

        // 拼接手机号
        const data = structuredClone(this.form)
        data.phoneNumber = `(+${this.countryId.split('+')[1].trim()})${data.phoneNumber}`

        // 判断是否进行邮箱验证，选择对应的地址发送注册请求
        const url = meta.emailValidation
          ? '/businese/user_info/regEmailUser'
          : '/businese/user_info/regCommonUser'
        axios({
          method: "post", url, data
        }).then(({code, msg}) => {
          if (code === 200) {
            this.goToLogin()
          } else {
            this.showDialog3 = true
            this.confirmInfo3 = msg
          }
        })
      } else {
        this.confirmInfo = this.$t('login["Please agree to the agreement"]')
        this.showDialog = true
      }
    },
    doReg() {
      if (!this.readInfo) {
        this.confirmInfo2 = this.$t('login["Please agree to the agreement"]')
        this.showDialog2 = true
        return
      }
      this.ajaxDoReg()
    },

    sendEmailCode() {
      if (!meta.emailValidation || this.emailValidation.getCodeButtonLabel !== this.$t('login[\'Get code\']')) {
        return
      }
      if (!this.form.email.trim()) {
        this.showDialog2 = true
        this.confirmInfo2 = this.$t('login[\'Please enter email address\']')
        return
      }
      if (this.sendingEmail) {
        return
      }
      this.sendingEmail = true
      axios({
        method: 'post',
        url: '/businese/user_info/sendRegCode?email=' + encodeURIComponent(this.form.email.trim()),
        timeout: 60000
      }).then(({ code, msg }) => {
        if (code === 200) {
          this.emailValidation.getCodeButtonLabel = 60
          const interval = setInterval(() => {
            this.emailValidation.getCodeButtonLabel--
            if (this.emailValidation.getCodeButtonLabel === 0) {
              this.emailValidation.getCodeButtonLabel = this.$t('login[\'Get code\']')
              clearInterval(interval)
            }
          }, 1000)
          this.confirmInfo2 = this.$t('login[\'Email sent successfully\']')
        } else {
          this.confirmInfo2 = msg || this.$t('login[\'Email send failed\']')
        }
        this.showDialog2 = true
      }).catch(() => {
        this.confirmInfo2 = this.$t('login[\'Cannot connect to server\']')
        this.showDialog2 = true
      }).finally(() => this.sendingEmail = false)
    },
  },
  mounted() {
    this.confirmInfo = this.$t('reg["Register your details to"]')
    this.showDialog = true
  }
}
</script>

<style scoped>

main {
  background-size: cover;
  z-index: 1;
  padding: 0 12px 50px;
  background-attachment: fixed;
}

#regPanel {
  width: 100%;
  background: linear-gradient(180deg, #FFFFFF 0%, #F7FEF1 100%);
  box-shadow: 0 7px 21px 0 rgba(5, 78, 171, 0.33);
  border-radius: 28px;
  position: relative;
}

#title {
  background: linear-gradient(180deg, #ECAF69 0%, #E5E899 100%);
  border-radius: 28px 28px 0 0;
  text-align: left;
  padding: 12px 0 12px 22px;
}

#panel {
  padding: 1.2rem 1rem 2rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ipt-wrap input {
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  height: 48px;
  background: #F9F9FA;
  border-radius: 14px;
  border: 1px solid #C8C8C8
}

.label-wrap {
  padding-left: 10px;
  margin-top: 10px;
}
.ipt-pwd-wrap input {
  margin-right: -35px;
  padding-right: 38px;
}
.ipt-pwd-wrap > .ipt-pwd-eye-wrap {
  height: 100%;
  vertical-align: middle;
  display: inline-block;
  width: 20px;
}
.ipt-pwd-wrap > .ipt-pwd-eye-wrap > img {
  width: 100%;
}

.ipt-phone-wrap {
  display: flex;
}
.ipt-phone-wrap > :first-child {
  width: 130px;
  flex: 0 0 auto;
}
.ipt-phone-wrap > :first-child /deep/ input {
  box-sizing: border-box;
  padding: 0 15px;
  height: 48px;
  background: #F9F9FA;
  border-radius: 14px 0 0 14px;
  border: 1px solid #C8C8C8;
  border-right: none;
}
.ipt-phone-wrap >  input:last-child {
  border-radius: 0 14px 14px 0;
}

#RegBtn {
  cursor: pointer;
  margin-top: 31px;
  background: linear-gradient(133deg, #F8B029 0%, #F6923D 100%);
  border-radius: 20px;

  width: 100%;
  height: 63px;
  text-align: center;
  line-height: 63px;
  color: #FFFFFF;
}
.loginBtn {
  height: 58px;
  background: linear-gradient(133deg, #F8B029 0%, #F6923D 100%);
  border-radius: 20px;
  padding: 0 20px;

  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 58px;
  text-align: center;
  font-style: normal;
  cursor: pointer;
}

.form-input-code {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
}

.ipt-code {
  flex: 1 1 auto;
}
.getCode {
  line-height: 1;
  height: unset;
  border-radius: 16px;
  font-size: unset;
  border: none;
  width: 109px;
  flex: 0 0 109px;
}
.mg {
  padding: 10vw 0;
}
</style>



// WEBPACK FOOTER //
// src/views/reg/index.vue